/**
 * Re-export of the shared Hero component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is — no
 * editor-specific field widgets.
 *
 * T-002: this file exists only to keep the existing import path
 * (`./components/homepage/HeroSection`) working. Future storefront
 * cleanup can replace these re-exports with direct imports from
 * `@launchstore/shared-puck`.
 *
 * Note: the `as any` cast is a pragmatic workaround for a TS variance
 * mismatch between the shared component's strictly-typed generics and
 * the generic `Config` slot in the storefront's Puck config. The
 * runtime behavior is identical. We'll revisit this when the rest of
 * the components are migrated in T-004.
 */

import { HeroSection as SharedHeroSection } from '@launchstore/shared-puck';

export const HeroSection: any = SharedHeroSection;
export type { HeroSectionProps } from '@launchstore/shared-puck';
